import * as React from "react";
import { forwardRef } from "react";
const SvgPhone = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M25 23L22 26L14 18L17 15L12 10L9 13C9 22.941 17.059 31 27 31L30 28L25 23Z", stroke: "currentColor", strokeWidth: 2, strokeMiterlimit: 10, strokeLinecap: "square" }));
const ForwardRef = forwardRef(SvgPhone);
export default ForwardRef;
